import { render } from "./TextArea.vue?vue&type=template&id=716c06f0&ts=true&lang=pug"
import script from "./TextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextArea.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__